var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("summary-section-layout", {
    attrs: {
      id: "assets",
      "section-title": _vm.$t("application-standalone.pages.assets.yourAssets"),
      "has-missing-information": _vm.hasMissingInformation,
      "section-visibility-values": _vm.sectionVisibilityValues,
    },
    on: {
      edit: function ($event) {
        return _vm.$emit("edit")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var applicant = ref.applicant
          return [
            !_vm.applicantHasAssets(applicant["assets"])
              ? _c("p", { staticClass: "text-light-gray" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.pages.submit.pleaseAddAssets"
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._l(applicant["assets"], function (asset, assetIndex) {
                  return _c("p", { key: assetIndex, staticClass: "mb-2" }, [
                    _vm.assetSummarySubtitle(asset)
                      ? _c("span", [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.assetSummarySubtitle(asset)) +
                              "\n      "
                          ),
                        ])
                      : _vm.hasMissingInformation
                      ? _c("span", { staticClass: "text-light-gray" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.pages.pleaseReviewThisSection"
                                )
                              ) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ])
                }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }